import { IFITracker } from '../../../cimsPage/instances/ifi'
import { Revert, Simple } from '../../common'

const object = 'Identified Field Issue'
const page = IFITracker

export const ViewIdentifiedFieldIssue = Simple({
  id: 'D7528FF3-1EB3-45BF-869D-30A999D0AFB4',
  action: 'View',
  object,
  page,
})

export const EditIdentifiedFieldIssue = Simple({
  id: '911DEFF5-D684-49F4-850D-A027964EB706',
  action: 'Edit',
  object,
  page,
})

export const ReviewIdentifiedFieldIssue = Simple({
  id: '7D5A4A28-851E-4735-97C7-20F9856B7460',
  action: 'Review',
  object,
  page,
})

export const RevertIdentifiedFieldIssue = Revert({
  id: 'C65A30C6-E5A5-421B-9F98-24DC5E8D6979',
  object,
  page,
})

export const CommentOnIdentifiedFieldIssue = Simple({
  id: '0626815E-8A23-4573-9C31-14CD50432E02',
  object,
  page,
  action: 'Comment on',
})

export type IFITrackerPermission =
  | typeof ViewIdentifiedFieldIssue
  | typeof EditIdentifiedFieldIssue
  | typeof ReviewIdentifiedFieldIssue
  | typeof RevertIdentifiedFieldIssue
  | typeof CommentOnIdentifiedFieldIssue
